import { DOCUMENT, inject, Injectable } from '@angular/core';
import { concat, defer, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalEventsService } from './global-events.service';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {
  private _document = inject<Document>(DOCUMENT);
  private _events = inject(GlobalEventsService);


  private _pageVisible$: Observable<boolean> = concat(
    defer(() => of(!this._document.hidden)),
    this._events.visibilityChangeEvent$.pipe(
      map(e => !this._document.hidden)
    )
  );

  public get pageIsVisible$() {
    return this._pageVisible$;
  }

}
